import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useLocation } from 'react-router-dom';

import { useEnvStore } from '../env';
import { useSubscriptionsStore } from '../subscriptions';
import { useProfileStore } from '.';

function useProfile() {
    const location = useLocation();
    const env = useEnvStore();
    const profileStore = useProfileStore();
    const subscriptionsStore = useSubscriptionsStore();

    const [profile, setProfile] = useState(profileStore.getDefaultProfile(true));
    const [devices, setDevices] = useState(profileStore.devices);
    const [type, setType] = useState('');

    // Boot data once — waits for env session to be fully initialized
    useEffect(() => {
        if (env.observed.initialized && !env.initializedOnce) {
            env.initializedOnce = true;
            initData();
        }
    }, [env.observed.initialized]);

    useEffect(() => {
        if (profileStore.profile) {
            setProfile(profileStore.profile);
        }
    }, [profileStore.observed.profile]);

    useEffect(() => {
        if (profileStore.devices) {
            setDevices(profileStore.devices);
        }
    }, [profileStore.observed.devices]);

    // Mirrors which OAuth type was used (google / outlook) — drives login UI pre-selection
    useEffect(() => {
        if (env.type) {
            setType(env.type);
        }
    }, [env.observed.type]);

    // Reset subscription expand state when navigating away from subscriptions
    useEffect(() => {
        if (!location.pathname.includes('subscriptions') && !isEmpty(subscriptionsStore.subscriptionsExpanded)) {
            subscriptionsStore.resetSubscriptionsExpanded();
        }
    }, [location]);

    async function initData() {
        Promise.allSettled([
            profileStore.getProfile(env.session),
            subscriptionsStore.getSubscriptions(),
            subscriptionsStore.getRecommendations(),
        ]);
    }

    function googleOauth() {
        profileStore.auth('google');
    }

    function outlookOauth() {
        profileStore.auth('outlook');
    }

    function handleProfileInputChange(obj) {
        setProfile({
            ...profile,
            [obj.target.name]: obj.target.value,
        });
    }

    return {
        googleOauth,
        outlookOauth,
        profile,
        devices,
        type,
        handleProfileInputChange,
    };
}

export default useProfile;
